<div class="navbar">
  <!-- This is the hamburger menu that triggers below 370px -->
  <div class="mobile-version__drawer-container">
    <button mat-button class="menu-button" (click)="sidenav.toggle()">
      <mat-icon>{{ isMenuOpen ? "menu_open" : "menu" }}</mat-icon>
    </button>
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav #sidenav autoFocus="false" mode="over" [(opened)]="isMenuOpen" class="sidenav" (click)="onSidenavClick()">
        <div class="drawer__buttons">
          <mat-accordion>
            <p class="menu-link" routerLink="/cereri" [class.menu-active]="'/cereri' === activeRoute" (click)="setActiveRoute('/cereri')">
              <img class="sidenav-request-btn" src="../../../../assets/icons/cereri.svg" alt="" />
              <span>Cereri</span>
            </p>
            <p *ngIf="permissionsService.hasPermission('urbanism-module.documents.official-documents.list')"
              class="menu-link" routerLink="/registru" [class.menu-active]="'/registru' === activeRoute" (click)="setActiveRoute('/registru')">
              <img src="../../../../assets/icons/registru.svg" alt="" />
              <span>Registru</span>
            </p>
            <p *ngIf="permissionsService.hasPermission('urbanism-module.documents.official-documents.list')"
              class="menu-link" routerLink="/registru-arhiva" [class.menu-active]="'/registru-arhiva' === activeRoute" (click)="setActiveRoute('/registru-arhiva')">
              <img src="../../../../assets/icons/registru.svg" alt="" />
              <span>Registru Arhivă</span>
            </p>
            <p *ngIf="permissionsService.hasPermission('urbanism-module.documents.official-documents.list')"
              class="menu-link" routerLink="/registru" [class.menu-active]="'/confirmare-documente' === activeRoute" (click)="setActiveRoute('/confirmare-documente')">
              <img src="../../../../assets/icons/confirmed-docs.svg" alt="" />
              <span>Confirmare Documente</span>
            </p>
            <p *ngIf="permissionsService.hasPermission('urbanism-module.settings') || permissionsService.hasPermission('urbanism-module.documents.official-documents-registry.list')"
              class="menu-link" routerLink="/settings" [class.menu-active]="'/settings' === activeRoute" (click)="setActiveRoute('/settings')">
              <img src="../../../../assets/icons/setari.svg" alt="" />
              <span>Setări</span>
            </p>

            <mat-expansion-panel *ngIf="permissionsService.hasPermission('urbanism-module.administrative')" 
              class="sidenav-accordion" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                <mat-panel-title class="sidenav-accordion">
                  <div class="panel-title">
                    <img src="../../../../assets/icons/administrative.svg" alt="" />
                    <span>Administrativ</span>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p routerLink="/admin-settings" class="settings-option-menu" [class.menu-active]="'/admin-settings' === activeRoute" (click)="setActiveRoute('/admin-settings')">
                <img src="../../../../assets/icons/setari.svg" alt="" />
                <span>Setări</span>
              </p>
            </mat-expansion-panel>
          </mat-accordion>

          <div class="footer">
            <div class="logout-button" (click)="logout()">
              <img src="assets/icons/logout.svg" alt="Deconectare" />
              <div class="logout-button--text">Deconectare</div>
            </div>
          </div>
        </div>
      </mat-sidenav>
      <mat-sidenav-content>
        <main>
          <!-- <router-outlet></router-outlet> -->
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>





  <div class="username">{{ username }}</div>
  <div class="username__icon">
    <div class="username__icon--letters">{{ usernameLetters }}</div>
  </div>
  <div class="notification" [popover]="popTemplateNotifications" [adaptivePosition]="true" #notificationsPopover="bs-popover"
    placement="bottom" container="body" boundariesElement="scrollParent">
    <div class="notifications" [ngClass]="{ 'move-up': !userNotifications && !isLoading }">
      <mat-spinner color="primary" diameter="40" *ngIf="isLoading"></mat-spinner>
      <img src="assets/icons/icon-bell.svg" alt="Notificari" />
      <div class="notifications--chip" [ngClass]="{ 'hide-chip': isLoading }">
        <span *ngIf="!isLoading && userNotifications">{{ userNotifications }}</span>
      </div>
    </div>

  </div>

  <ng-template #popTemplateNotifications>
    <p class="title">Aveți {{ userNotifications }} notificări</p>
    <div class="notification-popup d-flex flex-column">
      <div class="notification-message-container">
        <button type="button" class=" btn btn-light subtitle d-flex justify-content-start align-items-center gap-2" (click)="onButtonClick({id: '1', name: 'Cereri'})">
          <i class="fa-solid fa-envelope info"></i> {{notification['urbanism_modified']}} Cereri necesită atenția dvs.
        </button>

        <button type="button" class="btn btn-light subtitle d-flex justify-content-start align-items-center gap-2" (click)="onButtonClick({id: '2', name: 'Mesaje interne'})">
          <i class="fa-solid fa-triangle-exclamation warning"></i> {{notification['urbanism_messages']}} Mesaje interne pentru dvs.
        </button>
      </div>
    </div>
  </ng-template>
</div>